export interface CommentData {
    id: number;
    parent_id: number;
    content: string;
    author: {
        id: number,
        name: string
    };
    created_at: string;
    updated_at: string;
    children?: CommentData[],
    editable?: boolean
}

export enum CommentContainerType {
    FailReportComment = 1,
    RMATrackingComment = 2,
}